import { getPercent } from "@helpers";
import { InvestmentChartData } from "@helpers/charts/mergeCloseByDate";
import { prepareChartData } from "@components/Chart/highcharts/DrawLineChart";

export const calculatePercents = (
  quotes: InvestmentChartData[]
): InvestmentChartData[] => {
  let reference = quotes[0];
  let value = 1;
  let comparedValue = 1;

  return quotes.map((current) => {
    value *= current.value / reference.value;
    if (current.comparedValue && reference.comparedValue) {
      comparedValue *= current.comparedValue / reference.comparedValue;
    }

    reference = current;

    const percents = getPercent(value);
    const secondaryPercents = getPercent(comparedValue);

    return {
      ...current,
      value: percents,
      originalValue: current.value,
      eventsValue: percents,
      comparedValue: secondaryPercents,
      comparedOriginalValue: current.comparedValue,
    };
  });
};

export const prepareInvestmentsData = (
  chartData: InvestmentChartData[],
  chartColors: Record<string, string>,
  comparisonMode: boolean,
  hasComparedTicker?: boolean,
  isFetching?: boolean
) => {
  if (chartData.length === 0) return [];

  const data = comparisonMode ? calculatePercents(chartData) : chartData;

  const dataKeys = {
    all: "value",
    comparison: "comparedValue",
  } as const;

  const series = ["all"];

  if (hasComparedTicker && !isFetching) {
    series.push("comparison");
  }

  return prepareChartData(data, series, dataKeys, chartColors);
};
